var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15px",
    height: "15px",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1205 4955 c-382 -64 -726 -306 -952 -670 -289 -464 -332 -1073 -113 -1610 131 -322 323 -563 975 -1223 443 -450 1291 -1255 1350 -1283 52 -24 138 -24 190 0 59 28 907 833 1350 1283 652 660 844 901 974 1221 251 616 157 1312 -240 1791 -120 145 -249 253 -404 339 -208 116 -402 167 -640 167 -214 0 -367 -36 -564 -132 -190 -93 -329 -206 -519 -422 l-52 -60 -52 60 c-211 240 -371 364 -588 456 -103 44 -167 63 -284 83 -108 18 -320 18 -431 0z m447 -524 c42 -11 112 -38 155 -59 144 -73 206 -127 418 -364 137 -153 213 -229 240 -242 54 -27 150 -27 196 0 19 11 124 120 234 243 212 235 274 290 416 361 124 63 220 84 384 84 163 1 244 -15 372 -74 198 -92 366 -256 473 -466 193 -376 156 -883 -90 -1251 -115 -170 -363 -444 -791 -873 -407 -409 -1081 -1055 -1099 -1055 -18 0 -691 646 -1099 1055 -655 657 -832 877 -930 1153 -68 194 -93 447 -62 628 51 299 194 541 422 712 116 87 244 141 409 171 58 11 277 -4 352 -23z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.4dc88db4d6b4ee4fe023ce2bb7768ddf.svg";
export { ForwardRef as ReactComponent };